import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import HttpClient, { Callback, CallbackType, ExtraAction } from '../api';

export type ArticleCategory = {
  id: number;
  name: string;
  description: string;
  type: string;
};

const INITIAL_STATE: Array<ArticleCategory> = [];

const articleCategoriesSlice = createSlice({
  name: 'article-category',
  initialState: INITIAL_STATE,
  reducers: {
    addCategories: (state, action: PayloadAction<Array<ArticleCategory>>) => [
      ...state,
      ...action.payload,
    ],
  },
});

export const { addCategories } = articleCategoriesSlice.actions;

export default articleCategoriesSlice.reducer;

export const findArticleCategories = (
  extraActions?: Array<ExtraAction>,
  customErrorsMap = new Map<number, string>(),
  callbacks: Array<Callback> = [
    {
      type: CallbackType.SUCCESS,
      full: false,
      function: () => console.log('findArticleCategories success'),
    },
  ],
) => {
  return HttpClient.findArticleCategories(
    addCategories.type,
    customErrorsMap,
    extraActions,
    callbacks,
  );
};
